import { ApiClient } from "@api/ApiClient"

export class ChatbotApiClient {
  constructor(protected apiClient: ApiClient) { }

  public getChatbotVisitorVariablesPayload = () => {
    const url = `api/chatbot/visitor-variables-payload`
    return this.apiClient.get<string>(url).then(x => x.data)
  }
}